module.exports = __webpack_public_path__ + "img/控制器_control.efafb18b.svg";